import React from "react";

import {
  FlexWrapper,
  IconContainer,
  LabelContainer,
  ValueContainer,
  WholeWrapper,
} from "./components";

const DashboardWidget = ({ color, icon, label, value }) => {
  return (
    <WholeWrapper>
      <FlexWrapper>
        <IconContainer color={color}>{icon}</IconContainer>
        <ValueContainer> {value}</ValueContainer>
      </FlexWrapper>
      <LabelContainer>{label}</LabelContainer>
    </WholeWrapper>
  );
};

export default DashboardWidget;
